import { render, staticRenderFns } from "./Records.vue?vue&type=template&id=1790fd2c&scoped=true"
import script from "./Records.vue?vue&type=script&lang=js"
export * from "./Records.vue?vue&type=script&lang=js"
import style0 from "./Records.vue?vue&type=style&index=0&id=1790fd2c&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1790fd2c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/stage.cashnow.d-resources.com/releases/67404460/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1790fd2c')) {
      api.createRecord('1790fd2c', component.options)
    } else {
      api.reload('1790fd2c', component.options)
    }
    module.hot.accept("./Records.vue?vue&type=template&id=1790fd2c&scoped=true", function () {
      api.rerender('1790fd2c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/invoices/Records.vue"
export default component.exports